<template>
    <div>
        <div class='lt-sm absolute-center'>
            <div class='q-display-1'>Извините!</div>
            Раздел не оптимизирован для низкого разрешения.
        </div>
        <div class='gt-xs'>
            <q-card inline style="width: 100%" v-bind:class="{'q-mt-lg': $q.screen.lt.md}">
                <q-card-title>
                    Выбор периода                            
                </q-card-title>
                <q-card-separator />
                <q-card-main>
                    <div class='row full-width items-baseline'>
                        <q-datetime v-model="dateFrom" type="date"  clearable placeholder='Начало периода' inverted class='q-ma-xs' format="D MMMM YYYY"/>
                        <q-icon name ="fas fa-arrow-right" class='q-ml-md q-mr-md' color='grey-7'/>
                        <q-datetime v-model="dateTo" type="date"  clearable placeholder='Конец периода' inverted  class='q-ma-xs'  format="D MMMM YYYY"/>
                    </div>
                </q-card-main>

                <q-card-separator />
                <q-card-actions >
                    <div class="row no-wrap justify-between full-width">
                        <div class='row no-wrap'>
                            <q-icon flat round dense icon="event" />
                            <q-btn flat color='primary' label="Прошлый месяц" icon="event" @click="setPrevMonth"/>
                            <q-btn flat color= 'secondary' label="Этот месяц" icon="event" @click="setThisMonth"/>
                            <q-btn invert color= 'positive' label="Загрузить" outline icon="fas fa-play" @click='getPrihod' />
                        </div>
                        <q-btn  class='q-ml-lg' color='negative' outline icon="fas fa-filter"  label='Очистить фильтры' @click='clearFilters'/>
                    </div>
                </q-card-actions>
            </q-card>    
        </div>

            <q-card class='q-mt-md ellipsis-2-lines gt-xs'>

                <q-list>
                    <!-- заголовок таблицы -->
                    <q-item class='bg-primary' text-color='white'>
                        

                        <q-item-side style='width:8%'>
                            <q-item-tile class='q-caption text-center ellipsis' text-color="white" >Дата</q-item-tile>
                        </q-item-side>
                        <q-item-side style='width:20%'>
                            <q-select
                                    v-model="postavshikFilter"
                                    :options="postavshikList"
                                    color='white'
                                    inverted-light                                
                                    class='text-primary'
                                    float-label="Поставщик"
                                    clearable
                                />   
                        </q-item-side>
                    
                        <q-item-side  style='width:35%'>
                            <q-item-tile class='q-caption text-center ellipsis' text-color="white">
                                <q-select
                                    v-model="materialFilter"
                                    :options="materialList"
                                    color='white'
                                    inverted-light                                
                                    class='text-primary'
                                    float-label="Материал"
                                    clearable
                                />   
                            </q-item-tile>
                        </q-item-side>                    
                        <q-item-side  style='width:10%'>
                            <q-item-tile class='q-caption text-center ellipsis' text-color="white">Ширина</q-item-tile>
                        </q-item-side>
                        <q-item-side  style='width:10%'>
                            <q-item-tile class='q-caption text-center ellipsis' text-color="white" label>Кол-во</q-item-tile>
                        </q-item-side>
                        <q-item-side  style='width:10%'>
                            <q-item-tile class='q-caption text-center ellipsis' text-color="white" label>Цена(м<sup>2</sup>)</q-item-tile>
                        </q-item-side>
                    </q-item>
                </q-list>
                <div v-for="(item, key) in prihodList" :key=key class='myLine'>
                    <q-item class='myLine'>
                        <q-item-side style='width:8%' class='text-center'>
                            <q-item-tile label class='q-caption'>{{getNiceDate(item)}}</q-item-tile>
                        </q-item-side>

                        <q-item-side style='width:20%' class='text-center'>
                            <q-item-tile label class='q-caption'>{{getPostavshikName(item)}}</q-item-tile>
                        </q-item-side>

                        <q-item-side style='width:35%' class='text-center'>
                            <q-item-tile label class='q-caption'>{{getMaterialType(item)}}</q-item-tile>
                        </q-item-side>

                        <q-item-side style='width:10%' class='text-center'>
                            <q-item-tile label class='q-caption'>{{ getMaterialWidth(item) }} м</q-item-tile>
                        </q-item-side>

                        <q-item-side style='width:10%' class='text-center'>
                            <q-item-tile label class='q-caption'>{{ item.count }} м</q-item-tile>
                        </q-item-side>

                        <q-item-side style='width:10%' class='text-center'>
                            <q-item-tile label class='q-caption'>{{ item.price }} р/м<sup>2</sup></q-item-tile>
                        </q-item-side>


                    </q-item>
                    <q-card-separator/>
                </div>
            </q-card>


    </div>
</template>
<script>
/* eslint-disable */
export default {
    name : 'prihodList',
    data() {
        return {
            dateFrom : null,
            dateTo : null,
            postavshikFilter : null,
            materialFilter : null,
        }
    },
    created() {
        this.setThisMonth();
    },

    computed : {

        prihodList() {
            let q = this.$store.getters.getPrihodReport;                        
            return q.filter(item => {
                let result = true;
                result = this.postavshikFilter != null ? result && (item.postavshikId == this.postavshikFilter) : result;
                let n = this.$store.getters.getNomenklaturaById(item.materialId);
                result = ((this.materialFilter != null)&&(n!=null)) ? result && (n.type_id == this.materialFilter) : result;
                return result;
            }).sort((a, b) => {
                if (a.created_at>b.created_at) return -1;
                if (a.created_at<b.created_at) return 1;
                return 0;
            });

        },

        materialList() {
            let list = [];
            let q = this.$store.getters.getAllMaterials;
            q.forEach(element => {
                list.push({
                    label : element.name,
                    value : element.id,
                })
            });
            return list.sort((a,b)=>{
                if (a.label>b.label) return 1;
                if (a.label<b.label) return -1;
                return 0;
            });
        },

        postavshikList() {
            let result = [];
            let list = this.$store.getters.getPostavshiks != undefined ? this.$store.getters.getPostavshiks : [];
            list.forEach(item => {
                result.push({
                    label : item.name,
                    value : item.id,
                });
            });
            return result;
        },
    },

    methods : {
        getMaterialType(item) {
            if (item==null) return '-';
            let n = this.$store.getters.getNomenklaturaById(item.materialId);
            let m = n != null ? this.$store.getters.getMaterialById(n.type_id) : null;
            return m != null ? m.name : '-';
        },
        getMaterialWidth(item) {
            if (item==null) return '';
            let n = this.$store.getters.getNomenklaturaById(item.materialId);
            return n != null ? n.width : '-';
        },

        getPostavshikName(item) {
            if (item == null) return '-';
            let q = this.$store.getters.getPostavshikById(item.postavshikId);
            return q != null ? q.name : '-';
        },

        getNiceDate(item) {
            if (item == null) return '-';
            let d = new Date(item.created_at);
            return d != null ? d.toLocaleDateString() : '-';
        },

        clearFilters() {
            this.materialFilter = null;
            this.postavshikFilter = null;
        },

        getPrihod() {

           if ((this.dateFrom == null) || (this.dateTo == null)) {
                this.$admns.showNotify('Задайте период','error','Проверка данных');
            } else {
                // если что меняем местами даты
                let d1 = new Date(this.dateFrom);
                let d2 = new Date(this.dateTo);

                if (d1>d2) { // значит неправильное расположение дат - меняем местами
                    let q = this.dateFrom;
                    this.dateFrom = this.dateTo;
                    this.dateTo = q;
                }
                //надо скорректировать время: в ОТ поставить 0 часов, в ТУ поставить 23-59
                d1 = new Date(this.dateFrom); // опять получаем даты
                d2 = new Date(this.dateTo);
                d1.setHours(0, 0, 0);
                d2.setHours(23,59,59);
                
                // d2.setHours(23, 59, 59);

                this.$store.dispatch('getMaterialPrihod', {fromDate : d1, toDate : d2})
                .then()
                .catch(error=> {
                    console.log(error);
                    // this.$admn.showNotify('Ошибка при получении данных','error','Ошибка сервера');
                });
            }


        },

        setThisMonth() {
            let firstDate = new Date();
            firstDate.setDate(1);

            let lastDate = new Date();
            lastDate.setMonth(lastDate.getMonth()+1);
            lastDate.setDate(0);
            
            this.dateFrom = firstDate;
            this.dateTo = lastDate;

            this.getPrihod(); // сразу грузим данные
        },

        setPrevMonth() {
            let firstDate = new Date();
            let q = firstDate.getMonth()-1;
            firstDate.setMonth(q, 1);

            let lastDate = new Date();
            lastDate.setDate(0);

            this.dateFrom = firstDate.toDateString();
            this.dateTo = lastDate.toDateString();
            
            this.getPrihod(); // сразу грузим данные
        },

    }
}
</script>
<style lang="scss" scoped>
    .myLine{
        cursor : pointer;
        &:hover {
            background: rgb(221, 255, 221) !important;
        }
    }
</style>

